<template>
  <div class="index-order m__t--30">
    <b-tabs content-class="mt-3">
      <b-tab title="Attractions" active>
        <OrderAttractionList />
      </b-tab>
      <b-tab title="Packages">
        <OrderPackageList />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import OrderAttractionList from './OrderAttractionList';
import OrderPackageList from './OrderPackageList';

export default {
  name: 'order',
  components: {
    OrderAttractionList,
    OrderPackageList
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
.index-order {
  .nav-link {
    color: #0095e9;
  }
}
</style>
